<template>
  <Modal v-model="visible" title="添加到模板">
    <sl-select placeholder="请选择模板" v-model="tplId" :data="tpls"></sl-select>
    <div slot="footer">
      <Button type="primary" @click="handleSubmit()">保存</Button>
    </div>
  </Modal>
</template>
<script>
const tpls = [
  { id: 1, code: '00001', name: '试卷1', tempalteType: 1, totalScore: 100, organizeName: '绍兴邮管局', createDatetime: '2018-10-15T12:00:00' },
  { id: 2, code: '00002', name: '试卷2', tempalteType: 1, totalScore: 100, organizeName: '绍兴邮管局', createDatetime: '2018-10-15T12:00:00' },
  { id: 3, code: '00003', name: '试卷3', tempalteType: 1, totalScore: 100, organizeName: '绍兴邮管局', createDatetime: '2018-10-15T12:00:00' },
  { id: 4, code: '00004', name: '试卷4', tempalteType: 1, totalScore: 100, organizeName: '绍兴邮管局', createDatetime: '2018-10-15T12:00:00' },
  { id: 5, code: '00005', name: '试卷5', tempalteType: 1, totalScore: 100, organizeName: '绍兴邮管局', createDatetime: '2018-10-15T12:00:00' },
]
export default {
  data() {
    return {
      tpls:[],
      tplId:null,
      visible:false,
      answers:[]
    }
  },

  created() {
    this.prepare()
  },

  props: {
    
  },

  methods: {
    prepare(){
      this.$request.mock( tpls ).then( resp => {
        this.tpls = (resp.data || []).map( i => ({label:i.name , value : i.id}))
      })
    },
    add(data){
      this.visible = true
      this.tplId = null
      this.answers = data
    },
    save(){
      let params = { answers : this.answers , templateId : this.tplId }
      this.$request.mock(params).then( resp => {
        if( resp.code ){
          this.$Message.error( resp.msg )
        }else{
          this.$Message.success( '添加成功' )
          this.visible = false
        }
      })
    },
    handleSubmit(){
      this.save()
    }
  },
}

</script>
